module.exports = __webpack_public_path__ + "img/sumit-color.b516a91e.svg";